export default __webpack_public_path__ + "static/media/ag.677e23c7.svg";